<script setup lang="ts">
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import NeshanMap from '@components/ui/hotel&view/card-section/sections/NeshanMap.vue';

interface IProps {
    isLoading?: boolean;
    center: { lat: number; lng: number };
}

const { center } = defineProps<IProps>();

const emit = defineEmits<{
    close: [];
}>();
</script>

<template>
    <div class="map-container">
        <section class="map-section-container">
            <ClientOnly>
                <NeshanMap
                    :center="[center.lng, center.lat]"
                    :points="[]"
                    :simple-marker="{
                        lat: center.lat,
                        lng: center.lng,
                    }"
                />
            </ClientOnly>
            <mr-button
                class="close-fullscreen-button"
                :right-icon="faXmark"
                size="small"
                @click="emit('close')"
            >
                بستن تمام صفحه
            </mr-button>
        </section>
    </div>
</template>

<style lang="scss" scoped>
.map-container {
    position: fixed;
    inset: 0 0 0 0;
    z-index: 1000000000;
    background: white;
    .map-section-container {
        position: relative;
        flex: 1;
        border: 3px solid white;
        width: 100%;
        height: 100%;
        @include mobile-only {
            border-width: 0;
        }
        .google-map {
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 12px;
            :deep(.gm-style) {
                font-feature-settings: 'ss02' !important;
            }
        }
        .close-fullscreen-button {
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 400;
        }
        .map-zoom {
            position: absolute;
            z-index: 400;
            bottom: 40px;
            right: 40px;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .dec-zoom {
                margin-top: 8px;
            }
        }
    }
}
</style>
